// Generated by CoffeeScript 2.7.0
var App;

import BaseModel from './models/base_model.js';

import BaseController from './base_controller.js';

import Judgement from './judgement.js';

import Model from './models/index.js';

export default App = {BaseController, BaseModel, Judgement, Model};
